import { useAppContext } from 'context'
import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useAppManagementContext } from 'scenes/appManagement/context'

import AppSettingsLayout from './AppSettingsLayout'

const AppGeneralSettingsScene = lazy(() => import('./general'))
const AppMongoConnectorScene = lazy(() => import('./mongo'))
const AppSuperAdminSettingsScene = lazy(() => import('./superAdmin'))

export default function AppSettingsRouter() {
  const { viewerCanAccessMongo } = useAppManagementContext()
  const { isSuperAdmin } = useAppContext()

  return (
    <Suspense>
      <Routes>
        <Route path="/" element={<AppSettingsLayout />}>
          <Route path="" element={<Navigate to="general" replace />} />
          <Route path="general" element={<AppGeneralSettingsScene />} />
          {/* Legacy redirect: the old danger zone lived at settings/admin. */}
          <Route path="admin" element={<Navigate to="../general" replace />} />
          {viewerCanAccessMongo && (
            <>
              <Route path="mongo" element={<AppMongoConnectorScene />} />
              {/* Legacy redirect: the configure form lived at settings/mongo/configure. */}
              <Route
                path="mongo/configure"
                element={<Navigate to="../mongo" replace />}
              />
            </>
          )}
          {isSuperAdmin && (
            <Route
              path="super-admin"
              element={<AppSuperAdminSettingsScene />}
            />
          )}
          <Route path="*" element={<Navigate to="general" replace />} />
        </Route>
      </Routes>
    </Suspense>
  )
}
